/*	import { Component, PersonService, BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";
	import ContactList from "./ContactList.vue";
	import Extended from "./AttributeValueList.vue";
	import TrainingList from "../Training/TrainingList.vue";
	import EmploymentList from "../Employment/EmploymentEditList.vue";

	@Component({
		components: {
			"contact-list": ContactList,
			"extended-list": Extended,
			"employment-list": EmploymentList,
			"training-list": TrainingList
		}
	})
*/
	import { Component, PersonService, BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";

	export default abstract class PersonDetailBase extends BaseTLDetailComponent {
		alertModalTableId: string = 'modalSelectPerson';
		goBackUser: boolean = false;

		formData = {
			id: 0 as number,
			firstName: '' as string,
			lastName: '' as string,
			personalNumber: '' as string,
			idGroup: null as number | null, 
			idTenant: this.$store.state.idTenant as number,
			corUserId: 0 as number,
			corUserLogin: null as string | null
		};


		PersonService: PersonService = new PersonService();

		returnRoute: string = "PersonList";

		isNotAllowEdit() {
			return this.styleFormDelete || this.styleFormDetail;
		}
	
		roles: any[] = [];
		loginHistories: any[] = [];


		existPersonId() {
			return this.formData.id > 0;
		}



		async fetchData() {			
			this.formData.id = this.objectIdFromParam;
				this.PersonService.getById(this.formData.id).then((response) => {
					this.formData.personalNumber = response.data.personalNumber;
					this.formData.firstName = response.data.firstName;
					this.formData.lastName = response.data.lastName;
					this.formData.corUserId = response.data.corUserId;
					this.formData.corUserLogin = response.data.corUserLogin;
					this.formData.idGroup = response.data.idGroup
				});
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}


		doAction() {
		
			super.doCRUDActionWithInfoMessage('Vytvořen nový pracovník', 'Úspěšná úprava pracovníka', 'Úspěšně smazán pracovník');
		}

		saveAndContinue() {
			this.createPerson();
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			return this.PersonService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {
			return this.PersonService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {		
			return this.PersonService.delete(this.objectId);
		}

		showSaveButtonChild(isNormalSave: boolean) {
			return this.existPersonId() == isNormalSave && this.showSaveButton;
		}

		createPerson(): boolean {
			if (this.styleFormNew) {
				this.PersonService.create(this.formData).then((response) => {
					// VaP - po uspesnem vytvoreni noveho pracovnika nastavime formular do editacniho modu, abychom mohli zadavat i dalsi udaje
					this.styleFormDetail = true;
					this.styleFormNew = false;
					this.showAlertModalWithTitleAndContent('Info', 'Vytvořen nový pracovník');
					this.isSuccessfully = false;

					this.formData.id = Number(response.data.id);
/*					(this.$refs.extendeds as Extended).setPersonId(this.formData.id);
					(this.$refs.contacts as ContactList).setPersonId(this.formData.id);
					(this.$refs.employments as EmploymentList).setPersonId(this.formData.id);
					(this.$refs.training as TrainingList).setPersonId(this.formData.id);
	*/				
				}).catch((error) => {
					this.isSuccessfully = false;
					this.showAlertModalWithTitleAndContent('Chyba', JSON.stringify(error.response.data.errors));
				});
			}

			return this.isSuccessfully;
		}

		isUserConnect() {
			return this.formData.corUserId > 0;
		}		

		//nechat
		selectItem(select: any) {
			//je blbost davat do corUserLogin Number(select.id);
			// bu to ma byt userid nebo to nema byt number
			this.formData.corUserLogin = select.id;
		}

		goBack() {
			if (this.goBackUser) {
				this.detailUser();
			}
			else {
				this.$router.push({ name: this.returnRoute });
			}
		}

		//přechod na uživaele
		detailUser() {
			this.$router.push({ name: "UserDetail", params: { id: this.formData.corUserId.toString(), type: "details" } });
		}

		vFirstName: boolean = true;
		vLastName: boolean = true;
		vPersonalNumber: boolean = true;
		vPhone1: boolean = true;
		vPhone2: boolean = true;
		vProfession: boolean = true;
		vGroup: boolean = true;

		validate() {
			return !(this.vFirstName &&
				this.vLastName &&
				this.vPhone1 &&
				this.vPersonalNumber &&
				this.vPhone2 &&
				this.vProfession &&
				this.vGroup 
			);
		}


		isCorrectGroup(value: any) {
			this.vGroup = value;
		}

		isCorretFirstName(value: any) {
			this.vFirstName = value;
		}
		isCorrectLastName(value: any) {
			this.vLastName = value;
		}
		isCorrectPersonalNumber(value: any) {
			this.vPersonalNumber = value;
		}
		isCorrectPhone1(value: any) {
			this.vPhone1 = value;
		}
		isCorrectPhone2(value: any) {
			this.vPhone2 = value;
		}
		isCorrectProfession(value: any) {
			this.vProfession = value;
		}


	}


